const SOCIAL_USERNAME_RULE = /^[a-zA-Z0-9_.-]+$/; // допустимые символы, расширили с VK
const NORMAL_LOGIN_RULE = /^[a-zA-Z0-9-_]+$/;    // обычная валидация без соцсетей

// Универсальный валидатор части username без кода
export const validateSocialUsername = (username) => {
  // Длина: 5-32 символа
  if (username.length < 5 || username.length > 32) return false;

  // Допустимые символы: a-z A-Z 0-9 _ . -
  if (!SOCIAL_USERNAME_RULE.test(username)) return false;

  // Не начинается и не заканчивается на _
  if (username.startsWith('_') || username.endsWith('_')) return false;

  // Не начинается с более чем двух цифр подряд
  if (/^\d{3,}/.test(username)) return false;

  // Для частей, разделённых точкой: после точки min 4 символа, первый из которых — буква
  const parts = username.split('.');
  if (parts.length > 1) {
    for (let i = 1; i < parts.length; i++) {
      const part = parts[i];
      if (part.length < 4) return false;
      if (!/^[a-zA-Z]/.test(part)) return false;
    }
  }

  return true;
};

// Валидация полного формата username#code
export const validateSocialLogin = (val) => {
  const match = val.match(/^(.+)#(\d+)$/);
  if (!match) return false;

  const [_, username, code] = match;

  if (!validateSocialUsername(username)) return false;

  // code должен быть числовым (можно добавить дополнительные проверки по длине, если нужно)
  if (!/^\d+$/.test(code)) return false;

  return true;
};

// Основной валидатор логина
export const validateLogin = (val) => (
  NORMAL_LOGIN_RULE.test(val) || validateSocialLogin(val)
);

export default {
  validateLogin,
  validateSocialLogin,
  validateSocialUsername,
};
